export const DISPLAY_DATE_FORMAT = 'MM/dd/yyyy';
export const GRAPHQL_DATE_FORMAT = 'yyyy-MM-dd';
export const ONE_HOUR_IN_MILISECONDS: number = 3600000;
export const ONE_MINUTE_IN_MILISECONDS: number = 60000;
